"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "jobs-v2",
    path: "/jobs-v2",
    component: "JobsV2"
});
let JobsV2 = class JobsV2 extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    selectedItems;
    ds;
    async $$load_ds() {
        return this.$fn.slickDataSource('browse_a_job');
    }
    ux;
    b_7315092382398562_modalBindings;
    b_2248226175642056_columnDefaults;
    b_2248226175642056_columns;
    dataMembers = ['selectedItems', 'ds', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                selectedItems: [],
                ds: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
                b_2248226175642056_columnDefaults: {
                    filterable: true,
                    resizable: true,
                },
                b_2248226175642056_columns: [{
                        field: "number",
                        name: this.$fn.pgettext("Jobs", "Number"),
                        type: "command",
                        formatter: [{
                                name: "template",
                                format: "#{{ number }}",
                            },
                            {
                                name: "link",
                                href: "#",
                            },
                        ],
                    },
                    {
                        field: "parent_number",
                        name: this.$fn.pgettext("Jobs", "Parent"),
                        type: "command",
                        formatter: [{
                                name: "template",
                                format: "#{{ parent_number }}",
                            },
                            {
                                name: "link",
                                href: "#",
                            },
                        ],
                    },
                    {
                        field: "status",
                        name: this.$fn.pgettext("Jobs", "Status"),
                    },
                    {
                        field: "name",
                        name: this.$fn.pgettext("Jobs", "Job type"),
                    },
                    {
                        field: "bulk_job",
                        name: this.$fn.pgettext("Jobs", "Bulk"),
                        type: "boolean",
                        formatter: "checkbox",
                    },
                    {
                        field: "key",
                        name: this.$fn.pgettext("Jobs", "Key"),
                    },
                    {
                        field: "queue",
                        name: this.$fn.pgettext("Jobs", "Queue"),
                    },
                    {
                        field: "submit_time",
                        name: this.$fn.pgettext("Jobs", "Submit time"),
                        formatter: {
                            name: "datetime",
                        },
                    },
                    {
                        field: "created_by",
                        name: this.$fn.pgettext("Jobs", "Submitter"),
                        formatter: {
                            name: "user",
                        },
                    },
                ],
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("Jobs|Title", "Jobs"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_3480_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_setData_3482_getActionArgs($event) {
        return {
            path: "selectedItems",
            value: this.$refs.grid.getSelectedItems(),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_2248226175642056_selectedRowsChanged(event, scope) {
        return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_showModal_3484_getActionArgs($event) {
        return {
            name: "Job",
            props: {
                oid: $event.data.data.id,
            },
        };
    }
    async evh_2248226175642056_command_3483_getWhen($event) {
        return $event.data.column.id === 'number';
    }
    async act_2248226175642056_showModal_3486_getActionArgs($event) {
        return {
            name: "Job",
            props: {
                oid: $event.data.data.parent_id,
            },
        };
    }
    async evh_2248226175642056_command_3485_getWhen($event) {
        return $event.data.column.id === 'parent_number';
    }
    async evh_2248226175642056_command(event, scope) {
        return await this.actions.evh_2248226175642056_command.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_3480 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_3480_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_3479 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_3480,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_3479],
        });
        const act_2248226175642056_setData_3482 = new core_1.actions.SetDataAction({
            actionArgs: this.act_2248226175642056_setData_3482_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_selectedRowsChanged_3481 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_setData_3482,
            event: "selectedRowsChanged",
            displayName: "setData",
        });
        const evh_2248226175642056_selectedRowsChanged = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_selectedRowsChanged_3481],
        });
        const act_2248226175642056_showModal_3484 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2248226175642056_showModal_3484_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_command_3483 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_showModal_3484,
            event: "command",
            when: this.evh_2248226175642056_command_3483_getWhen,
            displayName: "showModal",
        });
        const act_2248226175642056_showModal_3486 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2248226175642056_showModal_3486_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_command_3485 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_showModal_3486,
            event: "command",
            when: this.evh_2248226175642056_command_3485_getWhen,
            displayName: "showModal",
        });
        const evh_2248226175642056_command = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_command_3483, evh_2248226175642056_command_3485],
        });
        return {
            act_7315092382398562_closeModal_3480,
            evh_7315092382398562_close_3479,
            evh_7315092382398562_close,
            act_2248226175642056_setData_3482,
            evh_2248226175642056_selectedRowsChanged_3481,
            evh_2248226175642056_selectedRowsChanged,
            act_2248226175642056_showModal_3484,
            evh_2248226175642056_command_3483,
            act_2248226175642056_showModal_3486,
            evh_2248226175642056_command_3485,
            evh_2248226175642056_command,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], JobsV2.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], JobsV2.prototype, "onSize", null);
JobsV2 = __decorate([
    (0, vue_property_decorator_1.Component)()
], JobsV2);
exports.default = JobsV2;
vue_property_decorator_1.Vue.component("JobsV2", JobsV2);
